import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './lang/i18n';
import { applyTranslationPatch } from './utils/translation_patches';
import { isChunkLoadError, triggerChunkReload } from './utils/lazyWithReload';

applyTranslationPatch();

let reloadScheduled = false;

function handleChunkLoadError() {
  if (reloadScheduled) return;
  reloadScheduled = true;

  const notification = document.createElement('div');
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #642ADB;
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    z-index: 10000;
    font-family: system-ui;
    font-size: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  `;
  notification.textContent = '🔄 Updating application...';
  document.body.appendChild(notification);

  if (!triggerChunkReload()) {
    reloadScheduled = false;
  }
}

window.addEventListener('error', (e) => {
  const message = e.message || '';
  const filename = e.filename || '';
  const filenameIsChunk = filename.includes('/assets/') && filename.includes('.js');

  if ((isChunkLoadError(message) || filenameIsChunk) && !reloadScheduled) {
    handleChunkLoadError();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  const reason = e.reason;
  if (isChunkLoadError(reason) && !reloadScheduled) {
    handleChunkLoadError();
  }
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);